/**
 * Format an HH:MM:SS time string to 12-hour AM/PM (e.g. "9:00 AM").
 *
 * @param {string} timeStr
 * @returns {string}
 */
export function formatTime(timeStr) {
  if (!timeStr) return '';
  const [h, m] = timeStr.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${ampm}`;
}

/**
 * Format a price using the currency code from the booking engine (e.g. "MXN").
 * Falls back to a plain "$" amount when no/invalid currency is provided.
 *
 * @param {number|string} amount
 * @param {string} [currency] ISO 4217 code, e.g. "MXN"
 * @returns {string}
 */
export function formatPrice(amount, currency) {
  const value = Number(amount) || 0;
  if (currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value);
    } catch {
      /* Unknown currency code — fall back to plain formatting below. */
    }
  }
  return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/**
 * Format an ISO date string (YYYY-MM-DD) to a localised date (e.g. "May 13, 2026").
 *
 * @param {string} isoDate
 * @returns {string}
 */
export function formatDate(isoDate) {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
